<template lang="pug">
  .page.page_offset_top.page_offset_bottom
    .page-meta
      .container
        .page-meta__inner.page-meta__inner_top
          breadcrumbs
          social.page-meta__social-list(theme="blue")
    .page-brand
      .container
        h1.title.title_size_l.text_center.page-brand__title Наш бренд
        h2.title.title_size_s.text_center.text_upper.page-brand__subtitle используйте только оригинальные логотипы и&nbsp;информацию о&nbsp;компании
        p.text_center.text_theme_gray.page-brand__desc По вопросам получения разрешения на использование логотипов просим писать на почту #[a(href="mailto:marketing@belkacar.ru") marketing@belkacar.ru]
        tabs(type="brand-tabs")
          tab(v-for="tab, index in tabs" :name="tab.name" :key="index" :selected="index == 0")
            .page-mediacenter__container
              .brand-card-list
                .brand-card-item
                  img(src="/static/img/brand-1.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-2.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-3.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item
                  img(src="/static/img/brand-4.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-5.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-6.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item
                  img(src="/static/img/brand-7.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item
                  img(src="/static/img/brand-8.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item
                  img(src="/static/img/brand-9.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-10.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-11.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item
                  img(src="/static/img/brand-12.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-13.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-14.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-15.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
                .brand-card-item.brand-card-item_square
                  img(src="/static/img/brand-16.jpg", alt="")
                  .brand-card-item__cover
                    a.btn.btn_theme_white.btn_size_m.brand-card-item__btn(href="#") Скачать
</template>

<script>
import Social from './../components/Social'
import Tabs from './../components/tabs'
import Tab from './../components/tab'

export default {
  name: 'News',
  components: { Social, Tabs, Tab },
  data () {
    return {
      tabs: [
        { name: 'Все' },
        { name: 'Логотип' },
        { name: 'Дневные фото' },
        { name: 'Ночные фото' },
        { name: 'Лайфстайл фото' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Brand.vue